import { useRef, useState, useEffect } from 'react';

const hasObserver = () => 'IntersectionObserver' in window;

export function useInView<T extends HTMLElement>(threshold = 0.12) {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(() => !hasObserver());

  useEffect(() => {
    const element = ref.current;

    if (!element || !hasObserver()) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [threshold]);

  return { ref, inView };
}
